import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@telus/koodo-ui-kit'

const Checkbox = ({
  checked, label, onChange, testId = '', hasError = false, disabled = false, ariaLabel
}) => {
  return (
    <span className="relative inline-flex items-center justify-center">
      <input
        type="checkbox"
        name={label}
        checked={checked}
        aria-label={ariaLabel}
        style={{
          width: '25px',
          height: '25px',
          outline: 'none',
          accentColor: 'transparent'
        }}
        onChange={(e) => onChange(e)}
        data-testid={testId}
        className={`appearance-none border-2 rounded bg-white cursor-pointer outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary ${hasError ? 'border-red focus:border-red' : 'border-black focus:border-black'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        disabled={disabled}
      />
      {checked && (
        <span
          className="absolute pointer-events-none text-primary"
          data-testid={testId ? `${testId}-check` : undefined}
        >
          <Icon
            accessibilityLabel="Checked"
            icon="Check"
            variant={{ size: 'micro', color:'offer' }}
          />
        </span>
      )}
    </span>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string
}

export default Checkbox
